import { FC } from "react";
import { useDispatch } from "react-redux";

import { GoogleIcon } from "../icons/GoogleIcon";
import { oAuthUser } from "../../store/auth/slice";
import { OAuthButtonProps } from "./types";
import { MicrosoftIcon } from "../icons/MicrosoftIcon";

import styles from "./OAuthButton.module.css";



const OAuthButton: FC<OAuthButtonProps> = ({ isRegister = false, isDisabled = false, titleGoogle = "", titleMicrosoft = "" }) => {
  const dispatch = useDispatch();

  const handleGoogle = () => {
    dispatch(oAuthUser({ type: 'google', isRegister }));
  };

  const handleMicrosoft = () => {
    dispatch(oAuthUser({ type: 'azure', isRegister }));
  };

  return (
    <div className={styles["oauth"]}>
      <button disabled={isDisabled} className={styles["oauth__btn"]} onClick={handleGoogle}>
        <GoogleIcon /> {titleGoogle}
      </button>
      <button disabled={isDisabled} className={styles["oauth__btn"]} onClick={handleMicrosoft}>
        <MicrosoftIcon /> {titleMicrosoft}
      </button>
    </div>
  );
};

export default OAuthButton;
